var ko = require('knockout'),
  filter = require('lodash/filter'),
  AUTHORIZATION_TYPE = require('_js/constants/authorization'),
  cart = require('_components/organisms/shopping-cart/shopping-cart-storage'),
  CalculatorTracking = require('../calculator-tracking');
require('knockout-postbox');

function CalculatorCourse(params) {
  this.parent = params.parent.parent;
  this.currentPage = params.parent.currentPage;
  this.data = params.data;
  this.API = params.api;
  this.planned = params.planned;
  this.completed = params.completed;
  this.index = params.index;
  var cartObject = this.data.CartObject;
  var isRNFri = this.parent.isRNFriProduct;
  var netCourse = cartObject.EventType === 3;
  var onsiteCourse = cartObject.EventType === 1;
  var showRNFriButton =
    (isRNFri && netCourse) ||
    (isRNFri && (onsiteCourse && cartObject.FreeOfChargeWithRnFri));
  this.isRNFriProduct = showRNFriButton;
  this.availability = getAvailability(this.data.Course.Availability);
  this.quickPurchaseOnlineCourse = this.parent.API.quickPurchaseOnlineCourse;
  var startAuth = window.authorizedAccountant
    ? AUTHORIZATION_TYPE.ACCOUNTANT
    : AUTHORIZATION_TYPE.AUDITOR;
  // Listen to the authorization type (accountant or "revisor").
  this.AuthorizationType = ko
    .observable(startAuth)
    .subscribeTo('authorizationType', true);
  // Filter the credits based on which authorization type to use.
  this.filteredCredits = ko.computed(function() {
    return filter(this.data.Course.ActiveAuthorizationCredits, {
      AuthorizationType: this.AuthorizationType()
    });
  }, this);
  this.purchased = ko.observable(
    cart.findCourseInCart(cart.getCart(), this.data.CartObject.Id)
      ? true
      : false
  );
  this.isExpanded = ko.observable(false);
  if (this.data.Course.FromDate !== null) {
    var date = new Date(this.data.Course.FromDate);
    this.dateFormatted =
      '' +
      date.getDate() +
      '.' +
      (date.getMonth() + 1) +
      '.' +
      date.getFullYear();
  }

  if (this.data.Course.ApprovedDate !== null) {
    var approvedDate = new Date(this.data.Course.ApprovedDate);
    this.approvedDateFormatted =
      '' +
      approvedDate.getDate() +
      '.' +
      (approvedDate.getMonth() + 1) +
      '.' +
      approvedDate.getFullYear();
  }

  ko.postbox.subscribe(
    'removeCourseWithKey',
    function(key) {
      if (key === this.data.CartObject.Key) {
        this.purchased(false);
      }
    },
    this,
    true
  );
}

CalculatorCourse.prototype.init = function(element) {
  this.$element = $(element);
  this.$expandable = $(this.$element.next('.expandable-course').get(0));
};

CalculatorCourse.prototype.buyCourse = function() {
  ko.postbox.publish('buyCourse', this.data.CartObject);
  this.purchased(true);
};

CalculatorCourse.prototype.expand = function() {
  var self = this;
  if (this.isExpanded()) {
    this.$expandable.slideUp(250, 'easeOutQuad', function() {
      self.isExpanded(!self.isExpanded());
      CalculatorTracking.trackCourseExpanded(
        self.data,
        'close',
        self.currentPage() + 1,
        self.index + 1
      );
    });
  } else {
    self.isExpanded(!self.isExpanded());
    this.$expandable.slideDown(250, 'easeOutQuad', function() {
      CalculatorTracking.trackCourseExpanded(
        self.data,
        'expand',
        self.currentPage() + 1,
        self.index + 1
      );
    });
  }
};

function getAvailability(availability) {
  if (!availability) return '';

  switch (availability.Status) {
    case 1:
      return 'open';
    case 2:
      return 'few';
    case 3:
    case 4:
      return 'full';
  }
}

module.exports = CalculatorCourse;
